document.addEventListener("DOMContentLoaded", function() {
  var questions = document.querySelectorAll('.bundle-lp-faq__question');
  
  questions.forEach(function(question, index) {
    question.addEventListener('click', function() {
      var isActive = this.classList.contains('bundle-lp-faq__question--active');
      questions.forEach(function(q) {
        q.classList.remove('bundle-lp-faq__question--active');
      });
      
      if (!isActive) {
        this.classList.add('bundle-lp-faq__question--active');
      }
    });

    // Expand the first question by default
    if (index === 0) {
      question.classList.add('bundle-lp-faq__question--active');
    }
  });
});
